/* Speradik — 2 hats for $80. DOM, cart and routing.

   All offer arithmetic lives in speradik-hat-model.js, which MUST load before this file: `defer`
   preserves document order, so a consumer placed earlier would find window.speradikHatModel
   undefined and die silently. This file holds no prices and no counting of its own — every
   decision is asked of the model, so the node oracle stays the single source of truth.

   The discount ($25 off each hat at qty 2+) is a live automatic rule in Shopify. This page adds
   two hats to the cart and lets Shopify apply it; it never inspects or asserts the discount.

   Cards and slots are rendered server-side by the Liquid section. This script only toggles their
   state — it never manifests content that was not already in the HTML on first paint. */
document.addEventListener('DOMContentLoaded', function () {
  'use strict';

  var M = window.speradikHatModel;
  var root = document.querySelector('[data-speradik]');
  if (!root || !M) return;            // gate defensively; never clobber good server state

  function json(sel, fallback) {
    var el = root.querySelector(sel);
    if (!el) return fallback;
    try { return JSON.parse(el.textContent); } catch (e) { return fallback; }
  }

  var CATALOG = json('[data-speradik-catalog]', []);
  var COPY = json('[data-speradik-copy]', {});
  if (!CATALOG.length) return;

  var CFG = {
    unit: parseInt(root.getAttribute('data-unit-price'), 10) || 6500,
    pair: parseInt(root.getAttribute('data-pair-price'), 10) || 8000,
    cartUrl: root.getAttribute('data-cart-url') || '/cart',
    checkoutUrl: root.getAttribute('data-checkout-url') || '/checkout',
    store: (root.getAttribute('data-store-url') || '').replace(/\/$/, ''),
    mode: root.getAttribute('data-mode') || 'auto'
  };
  var T = M.totals(CFG.unit, CFG.pair);

  var byId = {};
  CATALOG.forEach(function (c) { byId[String(c.id)] = c; });

  var state = M.createState();
  var busy = false;

  var els = {
    steps: Array.prototype.slice.call(root.querySelectorAll('[data-speradik-step]')),
    cards: Array.prototype.slice.call(root.querySelectorAll('[data-speradik-card]')),
    bar: root.querySelector('[data-speradik-bar]'),
    stepsTrack: root.querySelector('[data-speradik-steps]'),
    unlock: root.querySelector('[data-speradik-unlock]'),
    barCta: root.querySelector('[data-speradik-bar-submit]'),
    status: root.querySelector('[data-speradik-status]'),
    notice: root.querySelector('[data-speradik-notice]'),
    lines: root.querySelector('[data-speradik-lines]'),
    total: root.querySelector('[data-speradik-total]'),
    cta: root.querySelector('[data-speradik-submit]'),
    stickyCta: root.querySelector('[data-speradik-sticky-submit]'),
    stickyStatus: root.querySelector('[data-speradik-sticky-status]'),
    sticky: root.querySelector('[data-speradik-sticky]'),
    form: root.querySelector('[data-speradik-atc]'),
    grid: root.querySelector('[data-speradik-grid]')
  };

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m];
    });
  }
  function money(cents) { return '$' + (cents / 100).toFixed(2).replace(/\.00$/, ''); }
  function nameOf(id) { var c = byId[String(id)]; return c ? c.title : ''; }
  function fill(tpl, map) {
    return String(tpl || '').replace(/\{(\w+)\}/g, function (_, k) {
      return Object.prototype.hasOwnProperty.call(map, k) ? map[k] : '{' + k + '}';
    });
  }
  function useAjax() {
    if (CFG.mode === 'ajax') return true;
    if (CFG.mode === 'permalink') return false;
    return !!(window.Shopify && window.Shopify.shop) || /myshopify\.com$/.test(location.hostname);
  }

  /* ---------------------------------------------------------------- notices */
  function notice(text) {
    if (!els.notice) return;
    if (!text) { els.notice.hidden = true; els.notice.textContent = ''; return; }
    els.notice.hidden = false;
    els.notice.textContent = text;
  }

  /* ---------------------------------------------------------------- persistence
     Restored picks go through the model's pruner, never straight into state: a hat that sold out
     while the tab was closed must not reach submit. */
  var KEY = 'speradik:hats:v1';
  function save() {
    try { sessionStorage.setItem(KEY, JSON.stringify(state.slots)); } catch (e) {}
  }
  function load() {
    var stored;
    try { stored = JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (e) { return; }
    if (!Array.isArray(stored)) return;
    var restored = M.createState();
    stored.forEach(function (id) {
      if (id === null || id === undefined || !byId[String(id)]) return;
      restored = M.select(restored, id).state;
    });
    var pruned = M.pruneUnavailable(restored, CATALOG);
    state = pruned.state;
    if (pruned.dropped.length) {
      notice(fill(COPY.soldout_notice, { name: nameOf(pruned.dropped[0]) }));
    }
  }

  /* ---------------------------------------------------------------- analytics
     Publishes to pixels that already exist; nothing is installed here. */
  var OFFER_ID = '2-hats-for-80';
  function track(name, params) {
    try {
      if (window.Shopify && window.Shopify.analytics &&
          typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, params || {});
        return;
      }
      if (Array.isArray(window.dataLayer)) {
        var payload = { event: name };
        for (var k in (params || {})) {
          if (Object.prototype.hasOwnProperty.call(params, k)) payload[k] = params[k];
        }
        window.dataLayer.push(payload);
      }
    } catch (e) {}
  }

  /* ---------------------------------------------------------------- render */
  function render() {
    var n = M.count(state);
    var lines = M.items(state);
    var cta = M.ctaState(state);
    var qtyById = {};
    lines.forEach(function (l) { qtyById[String(l.id)] = l.quantity; });

    els.cards.forEach(function (card) {
      var id = card.getAttribute('data-speradik-card');
      var item = byId[id];
      var qty = qtyById[id] || 0;
      card.setAttribute('data-picked', qty ? 'true' : 'false');
      card.setAttribute('data-available', item && item.available === false ? 'false' : 'true');
      var badge = card.querySelector('[data-speradik-qty]');
      if (badge) badge.textContent = qty > 1 ? '×' + qty : '✓';
      var btn = card.querySelector('[data-speradik-pick]');
      if (btn) {
        /* A picked card says Remove, not "Picked": the border already states that it is in the
           pair, so the button's job is the way back out of it. */
        var label = qty ? COPY.card_remove : COPY.card_select;
        btn.textContent = label;
        btn.setAttribute('aria-pressed', qty ? 'true' : 'false');
        btn.setAttribute('data-mode', qty ? 'remove' : 'pick');
        var dead = item && item.available === false;
        btn.disabled = !!dead;
        btn.setAttribute('aria-label', label + ' — ' + (item ? item.title : ''));
      }
    });

    /* Three nodes: pick one, pick two, deal unlocked. A node is done once the pair has reached
       it, and active when it is the one the shopper is on. The reward node never shows a tick —
       it carries the $ through to the end. */
    els.steps.forEach(function (step, i) {
      var reward = step.hasAttribute('data-speradik-step-reward');
      var done = reward ? (cta === 'ready') : (n >= i + 1);
      var active = !reward && !done && n === i;
      step.classList.toggle('is-done', done);
      step.classList.toggle('is-active', active);
      step.setAttribute('aria-current', active ? 'step' : 'false');
    });
    if (els.stepsTrack) {
      els.stepsTrack.style.setProperty('--shat-step-fill', String(n / M.PAIR_SIZE));
    }
    if (els.bar) els.bar.classList.toggle('is-ready', cta === 'ready');
    if (els.unlock) els.unlock.textContent = cta === 'ready' ? COPY.unlock_copy_done : COPY.unlock_copy;
    if (els.barCta) {
      els.barCta.textContent = COPY.strip_checkout;
      els.barCta.disabled = cta !== 'ready' || busy;
    }

    var statusText = n === 0 ? COPY.progress_empty
                   : (n < M.PAIR_SIZE ? COPY.progress_partial : COPY.progress_complete);
    if (els.status) {
      els.status.textContent = statusText;
      els.status.setAttribute('data-complete', cta === 'ready' ? 'true' : 'false');
    }
    if (els.stickyStatus) els.stickyStatus.textContent = statusText;

    if (els.lines) {
      if (!lines.length) {
        els.lines.innerHTML = '<li class="shat-summary__line shat-summary__line--empty">' +
          esc(COPY.progress_empty) + '</li>';
      } else {
        els.lines.innerHTML = lines.map(function (l, li) {
          var item = byId[String(l.id)];
          var label = esc(item ? item.title : '') + (l.quantity > 1 ? ' ×' + l.quantity : '');
          return '<li class="shat-summary__line"><span>' + label + '</span><span>' +
                 esc(money(CFG.unit * l.quantity)) + '</span>' +
                 '<button type="button" class="shat-summary__drop" data-speradik-drop="' + li +
                 '" aria-label="Remove ' + esc(item ? item.title : '') + '">' +
                 esc(COPY.summary_remove) + '</button></li>';
        }).join('');
      }
    }
    if (els.total) {
      /* The struck total sits beside the number it qualifies, not at the far end of the row. */
      /* The lines list already carries the empty-state sentence; repeating it here read as a
         duplicated row. The total row only speaks once the pair is worth describing. */
      els.total.innerHTML = cta === 'ready'
        ? '<span>' + esc(statusText) + '</span><span class="shat-summary__figures">' +
          '<s>' + esc(money(T.was)) + '</s><b>' + esc(money(T.now)) + '</b></span>'
        : '<span></span><span class="shat-summary__figures">' +
          '<b>' + esc(money(CFG.unit * n)) + '</b></span>';
    }

    var label = cta === 'ready' ? COPY.cta_ready : (cta === 'partial' ? COPY.cta_partial : COPY.cta_empty);
    [els.cta, els.stickyCta].forEach(function (b) {
      if (!b) return;
      b.textContent = label;
      b.disabled = cta !== 'ready' || busy;
      b.setAttribute('aria-disabled', (cta !== 'ready' || busy) ? 'true' : 'false');
      b.setAttribute('data-busy', busy ? 'true' : 'false');
    });

    /* Keep the no-JS form inputs in step, so a submit that bypasses this script still adds the
       right two hats. */
    for (var i = 0; i < M.PAIR_SIZE; i++) {
      var idEl = root.querySelector('[data-speradik-line="' + i + '-id"]');
      var qtyEl = root.querySelector('[data-speradik-line="' + i + '-qty"]');
      var line = lines[i];
      if (idEl) idEl.value = line ? line.id : '';
      if (qtyEl) qtyEl.value = line ? line.quantity : '';
      if (idEl) idEl.disabled = !line;      // an empty id would 404 the native POST
      if (qtyEl) qtyEl.disabled = !line;
    }
  }

  /* ---------------------------------------------------------------- selection */
  function onSelect(variantId) {
    var item = byId[String(variantId)];
    if (!item || item.available === false) return;
    var r = M.select(state, variantId);
    state = r.state;
    notice(r.swappedOut === null ? '' :
      fill(COPY.swap_notice, { out: nameOf(r.swappedOut), in: item.title }));
    save(); render();
  }

  /* The summary lists LINES, and a line may be one hat at quantity 2. Releasing one unit of it
     is the honest reading of "remove" there, so find the first slot holding that variant. */
  function onRemoveVariant(variantId) {
    for (var i = 0; i < M.PAIR_SIZE; i++) {
      if (state.slots[i] === variantId) {
        state = M.removeSlot(state, i).state;
        notice(''); save(); render();
        return;
      }
    }
  }

  function onRemoveLine(lineIndex) {
    var line = M.items(state)[lineIndex];
    if (!line) return;
    for (var i = 0; i < M.PAIR_SIZE; i++) {
      if (state.slots[i] === line.id) { state = M.removeSlot(state, i).state; break; }
    }
    notice('');
    save(); render();
  }

  /* ---------------------------------------------------------------- submit */
  function submit() {
    if (M.ctaState(state) !== 'ready' || busy) return;
    var lines = M.items(state);

    if (!useAjax()) {                       // no Shopify runtime: hand off via cart permalink
      var utm = /utm_/.test(location.search) ? location.search.replace(/^\?/, '') : '';
      location.assign(CFG.store + '/cart/' + lines.map(function (x) {
        return x.id + ':' + x.quantity;
      }).join(',') + '?checkout' + (utm ? '&' + utm : ''));
      return;
    }

    busy = true; notice(''); render();
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: lines })
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) {
          var e = new Error(j.description || j.message || 'cart error');
          e.cart = true;
          throw e;
        }
        return j;
      });
    }).then(function () {
      var contents = lines.map(function (x) { return { id: String(x.id), quantity: x.quantity }; });
      track('AddToCart', {
        offer_id: OFFER_ID, value: CFG.pair / 100, currency: 'USD', content_type: 'product',
        contents: contents
      });
      track('InitiateCheckout', {
        offer_id: OFFER_ID, value: CFG.pair / 100, currency: 'USD',
        num_items: M.PAIR_SIZE, content_type: 'product', contents: contents
      });
      /* Straight to checkout: the pair is the whole page, so the cart page is a stop with
         nothing left to decide on it. CFG.cartUrl is kept for the sold-out path, where the
         shopper does need to see what is actually in the cart. */
      location.assign(CFG.checkoutUrl);
    }).catch(function (err) {
      busy = false;
      if (err && err.cart) soldOut(err); else notice(COPY.cart_error);
      render();
    });
  }

  /* Shopify tells us which line failed in prose, so match it against the catalog rather than
     guessing. Only the affected slot is released; the other pick survives. */
  function soldOut(err) {
    var detail = String((err && err.message) || '').toLowerCase();
    CATALOG.forEach(function (c) {
      var t = String(c.title || '').toLowerCase();
      var n = String(c.name || '').toLowerCase();
      if ((t && detail.indexOf(t) > -1) || (n && detail.indexOf(n) > -1)) c.available = false;
    });
    var pruned = M.pruneUnavailable(state, CATALOG);
    if (pruned.dropped.length) {
      state = pruned.state;
      notice(fill(COPY.soldout_notice, { name: nameOf(pruned.dropped[0]) }));
    } else {
      notice(COPY.cart_error);
    }
    save();
  }

  /* ---------------------------------------------------------------- wiring */
  if (els.grid) {
    els.grid.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-speradik-pick]');
      if (!btn) return;
      e.preventDefault();
      var id = Number(btn.getAttribute('data-speradik-pick'));
      if (btn.getAttribute('data-mode') === 'remove') onRemoveVariant(id);
      else onSelect(id);
    });
  }
  if (els.lines) {
    els.lines.addEventListener('click', function (e) {
      var drop = e.target.closest('[data-speradik-drop]');
      if (!drop) return;
      e.preventDefault();
      onRemoveLine(Number(drop.getAttribute('data-speradik-drop')));
    });
  }
  if (els.barCta) els.barCta.addEventListener('click', function (e) { e.preventDefault(); submit(); });

  /* Swipeable card media: on-body first, flat lay second. The track is a native scroll-snap
     container, so the dots only mirror and drive it — they never become the source of truth. */
  els.cards.forEach(function (card) {
    var track = card.querySelector('[data-speradik-track]');
    var dots = Array.prototype.slice.call(card.querySelectorAll('[data-speradik-dot]'));
    if (!track || !dots.length) return;
    function sync() {
      var i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
      dots.forEach(function (d, di) { d.setAttribute('aria-current', di === i ? 'true' : 'false'); });
    }
    track.addEventListener('scroll', function () {
      window.clearTimeout(track._t);
      track._t = window.setTimeout(sync, 60);
    }, { passive: true });
    dots.forEach(function (d, di) {
      d.addEventListener('click', function (e) {
        e.preventDefault();
        track.scrollTo({ left: track.clientWidth * di, behavior: 'smooth' });
      });
    });
    sync();
  });
  if (els.form) els.form.addEventListener('submit', function (e) { e.preventDefault(); submit(); });
  if (els.stickyCta) els.stickyCta.addEventListener('click', function (e) { e.preventDefault(); submit(); });

  /* The sticky bar exists only while the picker is off-screen, and only on narrow viewports. */
  if (els.sticky && els.grid && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      els.sticky.setAttribute('data-show', entries[0].isIntersecting ? 'false' : 'true');
    }, { rootMargin: '0px 0px -60% 0px' }).observe(els.grid);
  }

  load();
  render();
  track('ViewOffer', { offer_id: OFFER_ID, value: CFG.pair / 100, currency: 'USD' });
});
